import React from 'react'
import Typography from '../../Typography'

interface ILegendProps {
  children: React.ReactNode
}

const Legend = ({ children }: ILegendProps) => {
  return (
    <Typography as="legend" variant="body" size="l" bold>
      {children}
    </Typography>
  )
}

Legend.displayName = 'Form.Legend'
export default Legend
